export const config: Config = {
    baseUrl: process.env.VUE_APP_API_URL || "",
    version: process.env.VUE_APP_VERSION || "",
    oneSignalAppId: process.env.VUE_APP_ONESIGNAL_APPID || ""
};


interface Config {
    baseUrl: string;
    version: string;
    oneSignalAppId: string;
}
export function getApiUrl(path: string): string {

    let url = config.baseUrl || "";

    if (path.startsWith("/")) {
        path = path.slice(1);
    }

    if (url.endsWith("/")) {
        url = path.slice(0, url.length - 1);
    }

    url = url + "/" + path;
    return url;
}
